import action from 'app/lib/action';
import {DELETE_GOOD} from '../constants/actionTypes';

export default {
    request : (utrac, id) => action(DELETE_GOOD.REQUEST)({utrac, id}),
    success : (id) => action(DELETE_GOOD.SUCCESS)({id}),
    error   : (error) => action(DELETE_GOOD.ERROR)({error})
};